import { RunTotalAudit } from '../../../../../store/RunTotalAudit';
import { DetailPanelParams, FieldLabelMap } from '../../../../Compounds/DetailPanel/DetailPanel';

export const FIELD_LABEL_MAP: FieldLabelMap = {
  status: 'Status',
  auditType: 'Type',
  beforeSnapshotTimestamp: 'Before',
  afterSnapshotTimestamp: 'After',
  completedAt: 'Completed At',
  id: 'ID',
  createdAt: 'Created At',
  createdBy: 'Created By'
};

export const runTotalAuditSectionsInfo = (data: RunTotalAudit): DetailPanelParams[] => [
  {
    data,
    canEdit: [],
    fieldMap: FIELD_LABEL_MAP,
    order: ['status', 'auditType']
  }
];

export const runTotalAuditSectionMeta = (data: RunTotalAudit): DetailPanelParams[] => [
  {
    data,
    canEdit: [],
    fieldMap: FIELD_LABEL_MAP,
    order: ['completedAt', 'id', 'createdAt', 'createdBy']
  }
];
